import type { QuickInsertItem } from '@atlaskit/editor-common/provider-factory';

import { confluenceLocalStorageInstance as localStorage, keys } from '@confluence/storage-manager';

type ElementEntry = {
	element: string;
	count: number;
};

type ElementInsertionStats = {
	entries: ElementEntry[];
};

const getStatsFromLocalStorage = (): ElementInsertionStats => {
	const statsJson = localStorage.getItem(keys.ELEMENT_INSERTION_STATS);
	if (statsJson) {
		try {
			return JSON.parse(statsJson) as ElementInsertionStats;
		} catch {}
	}
	return { entries: [] };
};

const saveStatsToLocalStorage = (stats: ElementInsertionStats): void => {
	localStorage.setItem(keys.ELEMENT_INSERTION_STATS, JSON.stringify(stats));
};

export const incrementElementCount = (item: QuickInsertItem): boolean => {
	try {
		const element = item?.title;
		const stats = getStatsFromLocalStorage();
		const existingEntry = stats.entries.find((entry) => entry.element === element);

		if (existingEntry) {
			existingEntry.count += 1;
		} else {
			stats.entries.push({ element, count: 1 });
		}

		saveStatsToLocalStorage(stats);

		return true;
	} catch {
		return false;
	}
};

export const getAllElementInsertionStats = (): ElementEntry[] => {
	const stats = getStatsFromLocalStorage();
	return stats.entries;
};
